<template>
  <div class="root-box">
    <el-table :data="slots" :default-expand-all="false" :max-height="tableHeight" class="no-hover" ref="table" stripe>
      <el-table-column type="expand">
        <template slot-scope="props">
          <div class="table-expand">
            <el-table :data="props.row.vehicles" :show-header="true" size="small" class="no-hover">
              <el-table-column label="司机编号" prop="driverNo" width="100"></el-table-column>
              <el-table-column label="区域" width="120">
                <template slot-scope="scope">
                  {{ scope.row.areaId | enumTransfer(areaOpts, "id", "name") }}
                </template>
              </el-table-column>
              <el-table-column label="最后到达时间" width="150">
                <template slot-scope="scope">
                  {{ scope.row.lastArriveTime | dateFormat("yyyy-MM-dd hh:mm") }}
                </template>
              </el-table-column>
              <el-table-column label="座位" width="80">
                <template slot-scope="scope">{{ scope.row.seats }} 座</template>
              </el-table-column>
              <el-table-column label="剩余座位" width="90">
                <template slot-scope="scope">
                  <span class="red">{{ scope.row.leftSeats }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="时间段" prop="showTime" width="160"></el-table-column>
      <el-table-column label="空闲车辆" width="100">
        <template slot-scope="scope">{{ scope.row.vehicleCount }} 辆</template>
      </el-table-column>
      <el-table-column label="剩余座位">
        <template slot-scope="scope">
          <span class="red">{{ scope.row.totalLeftSeats }} 座</span>
          <el-button type="text" size="mini" @click="toggleRow(scope.row)">展开详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <span class="pagination-sum">
        峰值 {{ peakVehicleCount }} 辆 / {{ peakLeftSeats }} 座（{{ peakShowTime }}）
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    slots: {
      type: Array,
      default: () => []
    },
    tableHeight: {
      type: Number,
      default: 650
    }
  },
  computed: {
    ...mapState({
      areaOpts: (state) => state.areaList || []
    }),
    peakVehicleCount() {
      return (this.slots || []).reduce((max, item) => Math.max(max, item.vehicleCount || 0), 0);
    },
    peakLeftSeats() {
      const peak = (this.slots || []).reduce(
        (best, item) => ((item.vehicleCount || 0) > best.count ? { count: item.vehicleCount, seats: item.totalLeftSeats } : best),
        { count: 0, seats: 0 }
      );
      return peak.seats || 0;
    },
    peakShowTime() {
      const target = (this.slots || []).find((item) => item.vehicleCount === this.peakVehicleCount);
      return target ? target.showTime : "-";
    }
  },
  methods: {
    toggleRow(row) {
      this.$refs.table.toggleRowExpansion(row);
    }
  }
};
</script>

<style lang="less" scoped>
.root-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page {
  flex-shrink: 0;
}

.table-expand {
  padding: 0 0 0 48px;
}

.red {
  color: #f56c6c;
}

.pagination-sum {
  color: #f56c6c;
  margin-top: 4px;
  font-size: 12px;
  display: inline-block;
}
</style>
